import { useTranslation } from "react-i18next";
import {
  Col,
  ContentHeader,
  DesignTokens,
  MainContentArea,
  Row,
  ValueOrFallback,
} from "melco-ui";
import styled from "styled-components";
import { AddViewButton } from "../../components/reporting/machineStatus/AddViewButton";
import { useStatus } from "../../hooks/reporting/useStatus";
import { MachineStatusViewTabs } from "../../components/reporting/machineStatus/MachineStatusViewTabs";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import LoadingDefaultSpinIndicator from "../../components/loading/LoadingDefaultSpinIndicator";

export const MachineStatus: React.FC = () => {
  const { t } = useTranslation();

  const { data, isLoading } = useStatus();
  const { colors, spacings } = DesignTokens;
  const breadcrumb = useBreadcrumb("reporting");

  const EmptyViewWrapper = styled.div`
    border: 1px dashed ${colors.gray.middle};
    padding: ${spacings.middle}px;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const addView = (
    <>
      <Row gutter={[spacings.middle, spacings.middle]}>
        <Col xs={24} md={24} xl={24}>
          <div style={{ textAlign: "center" }}>{t('reporting.machinestatus.no_view_added')}</div>
        </Col>
        <Col xs={24} md={24} xl={24}>
          <div style={{ textAlign: "center" }}>
            <AddViewButton />
          </div>
        </Col>
      </Row>
    </>
  );

  // if(isLoading) {
  //   return <Spin />
  // }

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <ValueOrFallback
              value={t("main_menu.reporting_machine_status")}
              fallback={t("global.fallback.empty")}
            />
          }
          breadcrumb={breadcrumb}
          extra={
            <>
              <AddViewButton />
            </>
          }
        />
      }
      contentPadding
    >
      {
        <LoadingDefaultSpinIndicator isShown={isLoading}>
          <>
            {data && data.length == 0 && (
              <>
                <div>
                  <EmptyViewWrapper>{addView}</EmptyViewWrapper>
                </div>
              </>
            )}
            {data && data.length != 0 && (
              <>
                <MachineStatusViewTabs statusViews={data} />
              </>
            )}
          </>
        </LoadingDefaultSpinIndicator>
      }
    </MainContentArea>
  );
};
